export const Formes = {
    "Tauros-Paldea": {
        "NO": 128,
        "EN": "Combat Breed",
        "JP": "コンバット種",
        "FR": "Race Combative",
        "DE": "Gefechtvariante",
        "ES": "Variedad Combatiente",
        "IT": "Varietà Combattiva",
        "KOR": "컴뱃종",
        "CHS": "斗战种",
        "CHT": "鬥戰種",
        "SPRITE": "/images/sprites/a_128-1.png"
    },
    "Tauros-Paldea-Blaze": {
        "NO": 128,
        "EN": "Blaze Breed",
        "JP": "ブレイズ種",
        "FR": "Race Flamboyante",
        "DE": "Flammenvariante",
        "ES": "Variedad Ardiente",
        "IT": "Varietà Infuocata",
        "KOR": "블레이즈종",
        "CHS": "火熾種",
        "CHT": "火炽种",
        "SPRITE": "/images/sprites/a_128-2.png"
    },
    "Tauros-Paldea-Aqua": {
        "NO": 128,
        "EN": "Aqua Breed",
        "JP": "ウォーター種",
        "FR": "Race Aquatique",
        "DE": "Flutenvariante",
        "ES": "Variedad Acuática",
        "IT": "Varietà Acquatica",
        "KOR": "워터종",
        "CHS": "水瀾種",
        "CHT": "水澜种",
        "SPRITE": "/images/sprites/a_128-3.png"
    },
    "Castform": {
        "NO": 351,
        "EN": "Normal",
        "JP": "ポワルンのすがた",
        "FR": "Forme Normale",
        "DE": "Normalform",
        "ES": "Normal",
        "IT": "Forma Castform",
        "KOR": "캐스퐁의 모습",
        "CHS": "飘浮泡泡的样子",
        "CHT": "飄浮泡泡的樣子",
        "SPRITE": "/images/sprites/a_351.png"
    },
    "Castform-Sunny": {
        "NO": 351,
        "EN": "Sunny Form",
        "JP": "たいようのすがた",
        "FR": "Forme Solaire",
        "DE": "Sonnenform",
        "ES": "Forma Sol",
        "IT": "Forma Sole",
        "KOR": "태양의 모습",
        "CHS": "太阳的样子",
        "CHT": "太陽的樣子",
        "SPRITE": "/images/sprites/a_351-1.png"
    },
    "Castform-Rainy": {
        "NO": 351,
        "EN": "Rainy Form",
        "JP": "あまみずのすがた",
        "FR": "Forme Eau de Pluie",
        "DE": "Regenform",
        "ES": "Forma Lluvia",
        "IT": "Forma Pioggia",
        "KOR": "빗방울의 모습",
        "CHS": "雨水的样子",
        "CHT": "雨水的樣子",
        "SPRITE": "/images/sprites/a_351-2.png"
    },
    "Castform-Snowy": {
        "NO": 351,
        "EN": "Snowy Form",
        "JP": "ゆきぐものすがた",
        "FR": "Forme Blizzard",
        "DE": "Schneeform",
        "ES": "Forma Nieve",
        "IT": "Forma Nuvola di Neve",
        "KOR": "설운의 모습",
        "CHS": "雪雲的樣子",
        "CHT": "雪云的样子",
        "SPRITE": "/images/sprites/a_351-3.png"
    },
    "Kyogre-Primal": {
        "NO": 382,
        "EN": "Primal Kyogre",
        "JP": "ゲンシカイオーガ",
        "FR": "Primo-Kyogre",
        "DE": "Proto-Kyogre",
        "ES": "Kyogre Primigenio",
        "IT": "ArcheoKyogre",
        "KOR": "원시가이오가",
        "CHS": "原始蓋歐卡",
        "CHT": "原始蓋歐卡",
        "SPRITE": "/images/sprites/a_382.png"
    },
    "Groudon-Primal": {
        "NO": 383,
        "EN": "Primal Groudon",
        "JP": "ゲンシグラードン",
        "FR": "Primo-Groudon",
        "DE": "Proto-Groudon",
        "ES": "Groudon Primigenio",
        "IT": "ArcheoGroudon",
        "KOR": "원시그란돈",
        "CHS": "原始固拉多",
        "CHT": "原始固拉多",
        "SPRITE": "/images/sprites/a_383.png"
    },
    "Deoxys": {
        "NO": 386,
        "EN": "Normal Forme",
        "JP": "ノーマルフォルム",
        "FR": "Forme Normale",
        "DE": "Normalform",
        "ES": "Forma Normal",
        "IT": "Forma Normale",
        "KOR": "노말폼",
        "CHS": "普通形态",
        "CHT": "普通形態",
        "SPRITE": "/images/sprites/a_386.png"
    },
    "Deoxys-Attack": {
        "NO": 386,
        "EN": "Attack Forme",
        "JP": "アタックフォルム",
        "FR": "Forme Attaque",
        "DE": "Angriffsform",
        "ES": "Forma Ataque",
        "IT": "Forma Attacco",
        "KOR": "어택폼",
        "CHS": "攻击形态",
        "CHT": "攻擊形態",
        "SPRITE": "/images/sprites/a_386-1.png"
    },
    "Deoxys-Defense": {
        "NO": 386,
        "EN": "Defense Forme",
        "JP": "ディフェンスフォルム",
        "FR": "Forme Défense",
        "DE": "Verteidigungsform",
        "ES": "Forma Defensa",
        "IT": "Forma Difesa",
        "KOR": "디펜스폼",
        "CHS": "防御形态",
        "CHT": "防禦形態",
        "SPRITE": "/images/sprites/a_386-2.png"
    },
    "Deoxys-Speed": {
        "NO": 386,
        "EN": "Speed Forme",
        "JP": "スピードフォルム",
        "FR": "Forme Vitesse",
        "DE": "Initiativeform",
        "ES": "Forma Velocidad",
        "IT": "Forma Velocità",
        "KOR": "스피드폼",
        "CHS": "速度形态",
        "CHT": "速度形態",
        "SPRITE": "/images/sprites/a_386-3.png"
    },
    "Burmy": {
        "NO": 412,
        "EN": "Plant Cloak",
        "JP": "くさきのミノ",
        "FR": "Cape Plante",
        "DE": "Pflanzenumhang",
        "ES": "Tronco Planta",
        "IT": "Manto Pianta",
        "KOR": "초목도롱",
        "CHS": "草木蓑衣",
        "CHT": "草木蓑衣",
        "SPRITE": "/images/sprites/a_412.png"
    },
    "Burmy-Sandy": {
        "NO": 412,
        "EN": "Sandy Cloak",
        "JP": "すなちのミノ",
        "FR": "Cape Sable",
        "DE": "Sandumhang",
        "ES": "Tronco Arena",
        "IT": "Manto Sabbia",
        "KOR": "모래땅도롱",
        "CHS": "沙土蓑衣",
        "CHT": "砂土蓑衣",
        "SPRITE": "/images/sprites/a_412-1.png"
    },
    "Burmy-Trash": {
        "NO": 412,
        "EN": "Trash Cloak",
        "JP": "ゴミのミノ",
        "FR": "Cape Déchet",
        "DE": "Lumpenumhang",
        "ES": "Tronco Basura",
        "IT": "Manto Scarti",
        "KOR": "슈레도롱",
        "CHS": "垃圾蓑衣",
        "CHT": "垃圾蓑衣",
        "SPRITE": "/images/sprites/a_412-2.png"
    },
    "Wormadam": {
        "NO": 413,
        "EN": "Plant Cloak",
        "JP": "くさきのミノ",
        "FR": "Cape Plante",
        "DE": "Pflanzenumhang",
        "ES": "Tronco Planta",
        "IT": "Manto Pianta",
        "KOR": "초목도롱",
        "CHS": "草木蓑衣",
        "CHT": "草木蓑衣",
        "SPRITE": "/images/sprites/a_413.png"
    },
    "Wormadam-Sandy": {
        "NO": 413,
        "EN": "Sandy Cloak",
        "JP": "すなちのミノ",
        "FR": "Cape Sable",
        "DE": "Sandumhang",
        "ES": "Tronco Arena",
        "IT": "Manto Sabbia",
        "KOR": "모래땅도롱",
        "CHS": "沙土蓑衣",
        "CHT": "砂土蓑衣",
        "SPRITE": "/images/sprites/a_413-1.png"
    },
    "Wormadam-Trash": {
        "NO": 413,
        "EN": "Trash Cloak",
        "JP": "ゴミのミノ",
        "FR": "Cape Déchet",
        "DE": "Lumpenumhang",
        "ES": "Tronco Basura",
        "IT": "Manto Scarti",
        "KOR": "슈레도롱",
        "CHS": "垃圾蓑衣",
        "CHT": "垃圾蓑衣",
        "SPRITE": "/images/sprites/a_413-2.png"
    },
    "Cherrim": {
        "NO": 421,
        "EN": "Overcast Form",
        "JP": "ネガフォルム",
        "FR": "Temps Couvert",
        "DE": "Wolkenform",
        "ES": "Forma Encapotado",
        "IT": "Forma Nuvola",
        "KOR": "네거폼",
        "CHS": "陰天型態",
        "CHT": "陰天形態",
        "SPRITE": "/images/sprites/a_421.png"
    },
    "Cherrim-Sunshine": {
        "NO": 421,
        "EN": "Sunshine Form",
        "JP": "ポジフォルム",
        "FR": "Temps Ensoleillé",
        "DE": "Sonnenform",
        "ES": "Forma Soleado",
        "IT": "Forma Splendore",
        "KOR": "포지폼",
        "CHS": "晴天型態",
        "CHT": "晴天形態",
        "SPRITE": "/images/sprites/a_421-1.png"
    },
    "Shellos": {
        "NO": 422,
        "EN": "West Sea",
        "JP": "にしのうみ",
        "FR": "Mer Occident",
        "DE": "Westliches Meer",
        "ES": "Mar Oeste",
        "IT": "Mare Ovest",
        "KOR": "서쪽바다",
        "CHS": "西海",
        "CHT": "西海",
        "SPRITE": "/images/sprites/a_422.png"
    },
    "Shellos-East": {
        "NO": 422,
        "EN": "East Sea",
        "JP": "ひがしのうみ",
        "FR": "Mer Orient",
        "DE": "Östliches Meer",
        "ES": "Mar Este",
        "IT": "Mare Est",
        "KOR": "동쪽바다",
        "CHS": "东海",
        "CHT": "東海",
        "SPRITE": "/images/sprites/a_422-1.png"
    },
    "Gastrodon": {
        "NO": 423,
        "EN": "West Sea",
        "JP": "にしのうみ",
        "FR": "Mer Occident",
        "DE": "Westliches Meer",
        "ES": "Mar Oeste",
        "IT": "Mare Ovest",
        "KOR": "서쪽바다",
        "CHS": "西海",
        "CHT": "西海",
        "SPRITE": "/images/sprites/a_423.png"
    },
    "Gastrodon-East": {
        "NO": 423,
        "EN": "East Sea",
        "JP": "ひがしのうみ",
        "FR": "Mer Orient",
        "DE": "Östliches Meer",
        "ES": "Mar Este",
        "IT": "Mare Est",
        "KOR": "동쪽바다",
        "CHS": "东海",
        "CHT": "東海",
        "SPRITE": "/images/sprites/a_423-1.png"
    },
    "Rotom-Heat": {
        "NO": 479,
        "EN": "Heat Rotom",
        "JP": "ヒートロトム",
        "FR": "Motisma Chaleur",
        "DE": "Hitze-Rotom",
        "ES": "Rotom Calor",
        "IT": "Rotom Calore",
        "KOR": "히트로토무",
        "CHS": "加热洛托姆",
        "CHT": "加熱洛托姆",
        "SPRITE": "/images/sprites/a_479-1.png"
    },
    "Rotom-Wash": {
        "NO": 479,
        "EN": "Wash Rotom",
        "JP": "ウォッシュロトム",
        "FR": "Motisma Lavage",
        "DE": "Wasch-Rotom",
        "ES": "Rotom Lavado",
        "IT": "Rotom Lavaggio",
        "KOR": "워시로토무",
        "CHS": "清洗洛托姆",
        "CHT": "清洗洛托姆",
        "SPRITE": "/images/sprites/a_479-2.png"
    },
    "Rotom-Frost": {
        "NO": 479,
        "EN": "Frost Rotom",
        "JP": "フロストロトム",
        "FR": "Motisma Froid",
        "DE": "Frost-Rotom",
        "ES": "Rotom Frío",
        "IT": "Rotom Gelo",
        "KOR": "프로스트로토무",
        "CHS": "结冰洛托姆",
        "CHT": "結冰洛托姆",
        "SPRITE": "/images/sprites/a_479-3.png"
    },
    "Rotom-Fan": {
        "NO": 479,
        "EN": "Fan Rotom",
        "JP": "スピンロトム",
        "FR": "Motisma Hélice",
        "DE": "Wirbel-Rotom",
        "ES": "Rotom Ventilador",
        "IT": "Rotom Vortice",
        "KOR": "스핀로토무",
        "CHS": "旋转洛托姆",
        "CHT": "旋轉洛托姆",
        "SPRITE": "/images/sprites/a_479-4.png"
    },
    "Rotom-Mow": {
        "NO": 479,
        "EN": "Mow Rotom",
        "JP": "カットロトム",
        "FR": "Motisma Tonte",
        "DE": "Schneid-Rotom",
        "ES": "Rotom Corte",
        "IT": "Rotom Taglio",
        "KOR": "커트로토무",
        "CHS": "切割洛托姆",
        "CHT": "切割洛托姆",
        "SPRITE": "/images/sprites/a_479-5.png"
    },
    "Shaymin": {
        "NO": 492,
        "EN": "Land Forme",
        "JP": "ランドフォルム",
        "FR": "Forme Terrestre",
        "DE": "Landform",
        "ES": "Forma Tierra",
        "IT": "Forma Terra",
        "KOR": "랜드폼",
        "CHS": "陆上形态",
        "CHT": "陸上形態",
        "SPRITE": "/images/sprites/a_492.png"
    },
    "Shaymin-Sky": {
        "NO": 492,
        "EN": "Sky Forme",
        "JP": "スカイフォルム",
        "FR": "Forme Céleste",
        "DE": "Zenitform",
        "ES": "Forma Cielo",
        "IT": "Forma Cielo",
        "KOR": "스카이폼",
        "CHS": "天空形态",
        "CHT": "天空形態",
        "SPRITE": "/images/sprites/a_492-1.png"
    },
    "Basculin": {
        "NO": 550,
        "EN": "Red-Striped Form",
        "JP": "あかすじのすがた",
        "FR": "Motif Rouge",
        "DE": "Rotlinige Form",
        "ES": "Forma Raya Roja",
        "IT": "Forma Linearossa",
        "KOR": "적색근의 모습",
        "CHS": "红条纹的样子",
        "CHT": "紅條紋的樣子",
        "SPRITE": "/images/sprites/a_550.png"
    },
    "Basculin-Blue-Striped": {
        "NO": 550,
        "EN": "Blue-Striped Form",
        "JP": "あおすじのすがた",
        "FR": "Motif Bleu",
        "DE": "Blaulinige Form",
        "ES": "Forma Raya Azul",
        "IT": "Forma Lineablu",
        "KOR": "청색근의 모습",
        "CHS": "蓝条纹的样子",
        "CHT": "藍條紋的樣子",
        "SPRITE": "/images/sprites/a_550-1.png"
    },
    "Basculin-White-Striped": {
        "NO": 550,
        "EN": "White-Striped Form",
        "JP": "しろすじのすがた",
        "FR": "Motif Blanc",
        "DE": "Weißlinige Form",
        "ES": "Forma Raya Blanca",
        "IT": "Forma Lineabianca",
        "KOR": "백색근의 모습",
        "CHS": "白条纹的样子",
        "CHT": "白条纹的樣子",
        "SPRITE": "/images/sprites/a_550-2.png"
    },
    "Darmanitan-Galar": {
        "NO": 555,
        "EN": "Standard Mode",
        "JP": "ノーマルモード",
        "FR": "Mode Normal",
        "DE": "Normalmodus",
        "ES": "Modo Normal",
        "IT": "Stato Normale",
        "KOR": "노말모드",
        "CHS": "普通模式",
        "CHT": "一般模式",
        "SPRITE": "/images/sprites/a_egg.png"
    },
    "Darmanitan-Galar-Zen": {
        "NO": 555,
        "EN": "Zen Mode",
        "JP": "ダルマモード",
        "FR": "Mode Transe",
        "DE": "Trance-Modus",
        "ES": "Modo Daruma",
        "IT": "Stato Zen",
        "KOR": "달마모드",
        "CHS": "达摩模式",
        "CHT": "達摩模式",
        "SPRITE": "/images/sprites/a_egg.png"
    },
    "Darmanitan": {
        "NO": 555,
        "EN": "Standard Mode",
        "JP": "ノーマルモード",
        "FR": "Mode Normal",
        "DE": "Normalmodus",
        "ES": "Modo Normal",
        "IT": "Stato Normale",
        "KOR": "노말모드",
        "CHS": "普通模式",
        "CHT": "一般模式",
        "SPRITE": "/images/sprites/a_egg.png"
    },
    "Darmanitan-Zen": {
        "NO": 555,
        "EN": "Zen Mode",
        "JP": "ダルマモード",
        "FR": "Mode Transe",
        "DE": "Trance-Modus",
        "ES": "Modo Daruma",
        "IT": "Stato Zen",
        "KOR": "달마모드",
        "CHS": "达摩模式",
        "CHT": "達摩模式",
        "SPRITE": "/images/sprites/a_egg.png"
    },
    "Deerling": {
        "NO": 585,
        "EN": "Spring Form",
        "JP": "はるのすがた",
        "FR": "Forme Printemps",
        "DE": "Frühlingsform",
        "ES": "Forma Primavera",
        "IT": "Forma Primavera",
        "KOR": "봄의 모습",
        "CHS": "春天的样子",
        "CHT": "春天的樣子",
        "SPRITE": "/images/sprites/a_585.png"
    },
    "Deerling-Summer": {
        "NO": 585,
        "EN": "Summer Form",
        "JP": "なつのすがた",
        "FR": "Forme Été",
        "DE": "Sommerform",
        "ES": "Forma Verano",
        "IT": "Forma Estate",
        "KOR": "여름의 모습",
        "CHS": "夏天的样子",
        "CHT": "夏天的樣子",
        "SPRITE": "/images/sprites/a_585-1.png"
    },
    "Deerling-Autumn": {
        "NO": 585,
        "EN": "Autumn Form",
        "JP": "あきのすがた",
        "FR": "Forme Automne",
        "DE": "Herbstform",
        "ES": "Forma Otoño",
        "IT": "Forma Autunno",
        "KOR": "가을의 모습",
        "CHS": "秋天的样子",
        "CHT": "秋天的樣子",
        "SPRITE": "/images/sprites/a_585-2.png"
    },
    "Deerling-Winter": {
        "NO": 585,
        "EN": "Winter Form",
        "JP": "ふゆのすがた",
        "FR": "Forme Hiver",
        "DE": "Winterform",
        "ES": "Forma Invierno",
        "IT": "Forma Inverno",
        "KOR": "겨울의 모습",
        "CHS": "冬天的样子",
        "CHT": "冬天的樣子",
        "SPRITE": "/images/sprites/a_585-3.png"
    },
    "Sawsbuck": {
        "NO": 586,
        "EN": "Spring Form",
        "JP": "はるのすがた",
        "FR": "Forme Printemps",
        "DE": "Frühlingsform",
        "ES": "Forma Primavera",
        "IT": "Forma Primavera",
        "KOR": "봄의 모습",
        "CHS": "春天的样子",
        "CHT": "春天的樣子",
        "SPRITE": "/images/sprites/a_586.png"
    },
    "Sawsbuck-Summer": {
        "NO": 586,
        "EN": "Summer Form",
        "JP": "なつのすがた",
        "FR": "Forme Été",
        "DE": "Sommerform",
        "ES": "Forma Verano",
        "IT": "Forma Estate",
        "KOR": "여름의 모습",
        "CHS": "夏天的样子",
        "CHT": "夏天的樣子",
        "SPRITE": "/images/sprites/a_586-1.png"
    },
    "Sawsbuck-Autumn": {
        "NO": 586,
        "EN": "Autumn Form",
        "JP": "あきのすがた",
        "FR": "Forme Automne",
        "DE": "Herbstform",
        "ES": "Forma Otoño",
        "IT": "Forma Autunno",
        "KOR": "가을의 모습",
        "CHS": "秋天的样子",
        "CHT": "秋天的樣子",
        "SPRITE": "/images/sprites/a_586-2.png"
    },
    "Sawsbuck-Winter": {
        "NO": 586,
        "EN": "Winter Form",
        "JP": "ふゆのすがた",
        "FR": "Forme Hiver",
        "DE": "Winterform",
        "ES": "Forma Invierno",
        "IT": "Forma Inverno",
        "KOR": "겨울의 모습",
        "CHS": "冬天的样子",
        "CHT": "冬天的樣子",
        "SPRITE": "/images/sprites/a_586-3.png"
    },
    "Tornadus": {
        "NO": 641,
        "EN": "Incarnate Forme",
        "JP": "けしんフォルム",
        "FR": "Forme Avatar",
        "DE": "Inkarnationsform",
        "ES": "Forma Avatar",
        "IT": "Forma Incarnazione",
        "KOR": "화신폼",
        "CHS": "化身形态",
        "CHT": "化身形態",
        "SPRITE": "/images/sprites/a_641.png"
    },
    "Tornadus-Therian": {
        "NO": 641,
        "EN": "Therian Forme",
        "JP": "れいじゅうフォルム",
        "FR": "Forme Totémique",
        "DE": "Tiergeistform",
        "ES": "Forma Tótem",
        "IT": "Forma Totem",
        "KOR": "영물폼",
        "CHS": "灵兽形态",
        "CHT": "靈獸形態",
        "SPRITE": "/images/sprites/a_641-1.png"
    },
    "Thundurus": {
        "NO": 642,
        "EN": "Incarnate Forme",
        "JP": "けしんフォルム",
        "FR": "Forme Avatar",
        "DE": "Inkarnationsform",
        "ES": "Forma Avatar",
        "IT": "Forma Incarnazione",
        "KOR": "화신폼",
        "CHS": "化身形态",
        "CHT": "化身形態",
        "SPRITE": "/images/sprites/a_642.png"
    },
    "Thundurus-Therian": {
        "NO": 642,
        "EN": "Therian Forme",
        "JP": "れいじゅうフォルム",
        "FR": "Forme Totémique",
        "DE": "Tiergeistform",
        "ES": "Forma Tótem",
        "IT": "Forma Totem",
        "KOR": "영물폼",
        "CHS": "灵兽形态",
        "CHT": "靈獸形態",
        "SPRITE": "/images/sprites/a_642-1.png"
    },
    "Landorus": {
        "NO": 645,
        "EN": "Incarnate Forme",
        "JP": "けしんフォルム",
        "FR": "Forme Avatar",
        "DE": "Inkarnationsform",
        "ES": "Forma Avatar",
        "IT": "Forma Incarnazione",
        "KOR": "화신폼",
        "CHS": "化身形态",
        "CHT": "化身形態",
        "SPRITE": "/images/sprites/a_645.png"
    },
    "Landorus-Therian": {
        "NO": 645,
        "EN": "Therian Forme",
        "JP": "れいじゅうフォルム",
        "FR": "Forme Totémique",
        "DE": "Tiergeistform",
        "ES": "Forma Tótem",
        "IT": "Forma Totem",
        "KOR": "영물폼",
        "CHS": "灵兽形态",
        "CHT": "靈獸形態",
        "SPRITE": "/images/sprites/a_645-1.png"
    },
    "Kyurem-White": {
        "NO": 646,
        "EN": "White Kyurem",
        "JP": "ホワイトキュレム",
        "FR": "Kyurem Blanc",
        "DE": "Weißes Kyurem",
        "ES": "Kyurem Blanco",
        "IT": "Kyurem Bianco",
        "KOR": "화이트 큐레무",
        "CHS": "焰白酋雷姆",
        "CHT": "焰白酋雷姆",
        "SPRITE": "/images/sprites/a_646-1.png"
    },
    "Kyurem-Black": {
        "NO": 646,
        "EN": "Black Kyurem",
        "JP": "ブラックキュレム",
        "FR": "Kyurem Noir",
        "DE": "Schwarzes Kyurem",
        "ES": "Kyurem Negro",
        "IT": "Kyurem Nero",
        "KOR": "블랙 큐레무",
        "CHS": "暗黑酋雷姆",
        "CHT": "闇黑酋雷姆",
        "SPRITE": "/images/sprites/a_646-2.png"
    },
    "Keldeo": {
        "NO": 647,
        "EN": "Ordinary Form",
        "JP": "いつものすがた",
        "FR": "Aspect Normal",
        "DE": "Standardform",
        "ES": "Forma Habitual",
        "IT": "Forma Normale",
        "KOR": "평상시 모습",
        "CHS": "平常的样子",
        "CHT": "平常的樣子",
        "SPRITE": "/images/sprites/a_egg.png"
    },
    "Keldeo-Resolute": {
        "NO": 647,
        "EN": "Resolute Form",
        "JP": "かくごのすがた",
        "FR": "Aspect Décidé",
        "DE": "Resolutform",
        "ES": "Forma Brío",
        "IT": "Forma Risoluta",
        "KOR": "각오의 모습",
        "CHS": "觉悟的样子",
        "CHT": "覺悟的樣子",
        "SPRITE": "/images/sprites/a_egg.png"
    },
    "Meloetta": {
        "NO": 648,
        "EN": "Aria Forme",
        "JP": "ボイスフォルム",
        "FR": "Forme Chant",
        "DE": "Gesangsform",
        "ES": "Forma Lírica",
        "IT": "Forma Canto",
        "KOR": "보이스폼",
        "CHS": "歌声形态",
        "CHT": "歌聲形態",
        "SPRITE": "/images/sprites/a_648.png"
    },
    "Meloetta-Pirouette": {
        "NO": 648,
        "EN": "Pirouette Forme",
        "JP": "ステップフォルム",
        "FR": "Forme Danse",
        "DE": "Tanzform",
        "ES": "Forma Danza",
        "IT": "Forma Danza",
        "KOR": "스텝폼",
        "CHS": "舞步形态",
        "CHT": "舞步形態",
        "SPRITE": "/images/sprites/a_648-1.png"
    },
    "Greninja-Ash": {
        "NO": 658,
        "EN": "Ash-Greninja",
        "JP": "サトシゲッコウガ",
        "FR": "Sachanobi",
        "DE": "Ash-Quajutsu",
        "ES": "Greninja Ash",
        "IT": "Greninja-Ash",
        "KOR": "지우개굴닌자",
        "CHS": "小智版甲贺忍蛙",
        "CHT": "小智版甲賀忍蛙",
        "SPRITE": "/images/sprites/a_658-1.png"
    },
    "Aegislash": {
        "NO": 681,
        "EN": "Shield Forme",
        "JP": "シールドフォルム",
        "FR": "Forme Parade",
        "DE": "Schildform",
        "ES": "Forma Escudo",
        "IT": "Forma Scudo",
        "KOR": "실드폼",
        "CHS": "盾牌形态",
        "CHT": "盾牌形態",
        "SPRITE": "/images/sprites/a_681.png"
    },
    "Aegislash-Blade": {
        "NO": 681,
        "EN": "Blade Forme",
        "JP": "ブレードフォルム",
        "FR": "Forme Assaut",
        "DE": "Klingenform",
        "ES": "Forma Filo",
        "IT": "Forma Spada",
        "KOR": "블레이드폼",
        "CHS": "刀剑形态",
        "CHT": "刀劍形態",
        "SPRITE": "/images/sprites/a_681-1.png"
    },
    "Pumpkaboo": {
        "NO": 710,
        "EN": "Average Size",
        "JP": "ふつうのサイズ",
        "FR": "Taille Normale",
        "DE": "Größe M",
        "ES": "Tamaño Normal",
        "IT": "Normale",
        "KOR": "보통 사이즈",
        "CHS": "普通尺寸",
        "CHT": "普通尺寸",
        "SPRITE": "/images/sprites/a_710.png"
    },
    "Pumpkaboo-Small": {
        "NO": 710,
        "EN": "Small Size",
        "JP": "ちいさいサイズ",
        "FR": "Taille Mini",
        "DE": "Größe S",
        "ES": "Tamaño Pequeño",
        "IT": "Mini",
        "KOR": "작은 사이즈",
        "CHS": "小尺寸",
        "CHT": "小尺寸",
        "SPRITE": "/images/sprites/a_710-1.png"
    },
    "Pumpkaboo-Large": {
        "NO": 710,
        "EN": "Large Size",
        "JP": "おおきいサイズ",
        "FR": "Taille Maxi",
        "DE": "Größe L",
        "ES": "Tamaño Grande",
        "IT": "Grande",
        "KOR": "큰 사이즈",
        "CHS": "大尺寸",
        "CHT": "大尺寸",
        "SPRITE": "/images/sprites/a_710-2.png"
    },
    "Pumpkaboo-Super": {
        "NO": 710,
        "EN": "Super Size",
        "JP": "とくだいサイズ",
        "FR": "Taille Ultra",
        "DE": "Größe XL",
        "ES": "Tamaño Extragrande",
        "IT": "Maxi",
        "KOR": "특대 사이즈",
        "CHS": "特大尺寸",
        "CHT": "特大尺寸",
        "SPRITE": "/images/sprites/a_710-3.png"
    },
    "Oricorio": {
        "NO": 741,
        "EN": "Baile Style",
        "JP": "めらめらスタイル",
        "FR": "Style Flamenco",
        "DE": "Flamenco-Stil",
        "ES": "Estilo Apasionado",
        "IT": "Stile Flamenco",
        "KOR": "이글이글스타일",
        "CHS": "热辣热辣风格",
        "CHT": "熱辣熱辣風格",
        "SPRITE": "/images/sprites/a_741.png"
    },
    "Oricorio-Pom-Pom": {
        "NO": 741,
        "EN": "Pom-Pom Style",
        "JP": "ぱちぱちスタイル",
        "FR": "Style Pom-Pom",
        "DE": "Cheerleading-Stil",
        "ES": "Estilo Animado",
        "IT": "Stile Cheerdance",
        "KOR": "파칙파칙스타일",
        "CHS": "啪滋啪滋风格",
        "CHT": "啪滋啪滋風格",
        "SPRITE": "/images/sprites/a_741-1.png"
    },
    "Oricorio-Pa'u": {
        "NO": 741,
        "EN": "Pa'u Style",
        "JP": "ふらふらスタイル",
        "FR": "Style Hula",
        "DE": "Hula-Stil",
        "ES": "Estilo Plácido",
        "IT": "Stile Hula",
        "KOR": "훌라훌라스타일",
        "CHS": "呼拉呼拉风格",
        "CHT": "呼拉呼拉風格",
        "SPRITE": "/images/sprites/a_741-2.png"
    },
    "Oricorio-Sensu": {
        "NO": 741,
        "EN": "Sensu Style",
        "JP": "まいまいスタイル",
        "FR": "Style Buyō",
        "DE": "Buyo-Stil",
        "ES": "Estilo Refinado",
        "IT": "Stile Buyō",
        "KOR": "하늘하늘스타일",
        "CHS": "轻盈轻盈风格",
        "CHT": "輕盈輕盈風格",
        "SPRITE": "/images/sprites/a_741-3.png"
    },
    "Lycanroc": {
        "NO": 745,
        "EN": "Midday Form",
        "JP": "まひるのすがた",
        "FR": "Forme Diurne",
        "DE": "Tagform",
        "ES": "Forma Diurna",
        "IT": "Forma Giorno",
        "KOR": "한낮의모습",
        "CHS": "白昼的样子",
        "CHT": "白晝的樣子",
        "SPRITE": "/images/sprites/a_745.png"
    },
    "Lycanroc-Midnight": {
        "NO": 745,
        "EN": "Midnight Form",
        "JP": "まよなかのすがた",
        "FR": "Forme Nocturne",
        "DE": "Nachtform",
        "ES": "Forma Nocturna",
        "IT": "Forma Notte",
        "KOR": "한밤중의 모습",
        "CHS": "黑夜的样子",
        "CHT": "黑夜的樣子",
        "SPRITE": "/images/sprites/a_745-1.png"
    },
    "Lycanroc-Dusk": {
        "NO": 745,
        "EN": "Dusk Form",
        "JP": "たそがれのすがた",
        "FR": "Forme Crépusculaire",
        "DE": "Zwielichtform",
        "ES": "Forma Crepuscular",
        "IT": "Forma Crepuscolo",
        "KOR": "황혼의 모습",
        "CHS": "黄昏的样子",
        "CHT": "黃昏的樣子",
        "SPRITE": "/images/sprites/a_745-2.png"
    },
    "Wishiwashi": {
        "NO": 746,
        "EN": "Solo Form",
        "JP": "たんどくのすがた",
        "FR": "Forme Solitaire",
        "DE": "Einzelform",
        "ES": "Forma Individual",
        "IT": "Forma Individuale",
        "KOR": "단독의 모습",
        "CHS": "单独的样子",
        "CHT": "單獨的樣子",
        "SPRITE": "/images/sprites/a_746.png"
    },
    "Wishiwashi-School": {
        "NO": 746,
        "EN": "School Form",
        "JP": "むれたすがた",
        "FR": "Forme Banc",
        "DE": "Schwarmform",
        "ES": "Forma Banco",
        "IT": "Forma Banco",
        "KOR": "군집의 모습",
        "CHS": "鱼群的样子",
        "CHT": "魚群的樣子",
        "SPRITE": "/images/sprites/a_746-1.png"
    },
    "Mimikyu": {
        "NO": 778,
        "EN": "Disguised Form",
        "JP": "ばけたすがた",
        "FR": "Forme Déguisée",
        "DE": "Verkleidete Form",
        "ES": "Forma Encubierta",
        "IT": "Forma Mascherata",
        "KOR": "둔갑한 모습",
        "CHS": "化形的样子",
        "CHT": "化形的樣子",
        "SPRITE": "/images/sprites/a_778.png"
    },
    "Mimikyu-Busted": {
        "NO": 778,
        "EN": "Busted Form",
        "JP": "ばれたすがた",
        "FR": "Forme Démasquée",
        "DE": "Entlarvte Form",
        "ES": "Forma Descubierta",
        "IT": "Forma Smascherata",
        "KOR": "들킨 모습",
        "CHS": "现形的样子",
        "CHT": "現形的樣子",
        "SPRITE": "/images/sprites/a_778-1.png"
    },
    "Toxtricity": {
        "NO": 849,
        "EN": "Amped Form",
        "JP": "ハイなすがた",
        "FR": "Forme Aigüe",
        "DE": "Hoch-Form",
        "ES": "Forma Aguda",
        "IT": "Forma Melodia",
        "KOR": "하이한 모습",
        "CHS": "高调的样子",
        "CHT": "高調的樣子",
        "SPRITE": "/images/sprites/a_849.png"
    },
    "Toxtricity-Low-Key": {
        "NO": 849,
        "EN": "Low Key Form",
        "JP": "ローなすがた",
        "FR": "Forme Grave",
        "DE": "Tief-Form",
        "ES": "Forma Grave",
        "IT": "Forma Basso",
        "KOR": "로우한 모습",
        "CHS": "低调的样子",
        "CHT": "低調的樣子",
        "SPRITE": "/images/sprites/a_849-1.png"
    },
    "Sinistea": {
        "NO": 855,
        "EN": "Phony Form",
        "JP": "がんさくフォルム",
        "FR": "Forme Contrefaçon",
        "DE": "Fälschungsform",
        "ES": "Forma Arcaica",
        "IT": "Forma Contraffatta",
        "KOR": "위작품",
        "CHS": "赝品形态",
        "CHT": "贗品形態",
        "SPRITE": "/images/sprites/a_855.png"
    },
    "Sinistea-Antique": {
        "NO": 855,
        "EN": "Antique Form",
        "JP": "しんさくフォルム",
        "FR": "Forme Authentique",
        "DE": "Originalform",
        "ES": "Forma Genuina",
        "IT": "Forma Autentica",
        "KOR": "진작품",
        "CHS": "真品形态",
        "CHT": "真品形態",
        "SPRITE": "/images/sprites/a_855-1.png"
    },
    "Eiscue": {
        "NO": 875,
        "EN": "Ice Face",
        "JP": "アイスフェイス",
        "FR": "Tête de Gel",
        "DE": "Tiefkühlkopf",
        "ES": "Cara de Hielo",
        "IT": "Gelofaccia",
        "KOR": "아이스페이스",
        "CHS": "结冻头",
        "CHT": "結凍頭",
        "SPRITE": "/images/sprites/a_875.png"
    },
    "Eiscue-Noice": {
        "NO": 875,
        "EN": "Noice Face",
        "JP": "ナイスフェイス",
        "FR": "Tête Dégel",
        "DE": "Wohlfühlkopf",
        "ES": "Cara Deshielo",
        "IT": "Liquefaccia",
        "KOR": "나이스페이스",
        "CHS": "解冻头",
        "CHT": "解凍頭",
        "SPRITE": "/images/sprites/a_875-1.png"
    },
    "Morpeko": {
        "NO": 877,
        "EN": "Full Belly Mode",
        "JP": "まんぷくもよう",
        "FR": "Mode Rassasié",
        "DE": "Pappsattmuster",
        "ES": "Forma Saciada",
        "IT": "Motivo Panciapiena",
        "KOR": "배부른 모양",
        "CHS": "满腹花纹",
        "CHT": "滿腹花紋",
        "SPRITE": "/images/sprites/a_877.png"
    },
    "Morpeko-Hangry": {
        "NO": 877,
        "EN": "Hangry Mode",
        "JP": "はらぺこもよう",
        "FR": "Mode Affamé",
        "DE": "Kohldampfmuster",
        "ES": "Forma Voraz",
        "IT": "Motivo Panciavuota",
        "KOR": "배고픈 모양",
        "CHS": "空腹花纹",
        "CHT": "空腹花紋",
        "SPRITE": "/images/sprites/a_877-1.png"
    },
    "Maushold-Four": {
        "NO": 946,
        "EN": "Family of Four",
        "JP": "４ひきかぞく",
        "FR": "Famille de Quatre",
        "DE": "Viererfamilie",
        "ES": "Familia de Cuatro",
        "IT": "Quadrifamiglia",
        "KOR": "네 식구",
        "CHS": "四只家庭",
        "CHT": "四隻家庭",
        "SPRITE": "/images/sprites/a_946.png"
    },
    "Maushold-Three": {
        "NO": 946,
        "EN": "Family of Three",
        "JP": "３びきかぞく",
        "FR": "Famille de Trois",
        "DE": "Dreierfamilie",
        "ES": "Familia de Tres",
        "IT": "Trifamiglia",
        "KOR": "세 식구",
        "CHS": "三只家庭",
        "CHT": "三隻家庭",
        "SPRITE": "/images/sprites/a_946-1.png"
    },
    "Squawkabilly-Green": {
        "NO": 960,
        "EN": "Green Plumage",
        "JP": "グリーンフェザー",
        "FR": "Plumage Vert",
        "DE": "Grüngefiedert",
        "ES": "Plumaje Verde",
        "IT": "Piume Verdi",
        "KOR": "그린 페더",
        "CHS": "绿羽毛",
        "CHT": "綠羽毛",
        "SPRITE": "/images/sprites/a_960.png"
    },
    "Squawkabilly-Blue": {
        "NO": 960,
        "EN": "Blue Plumage",
        "JP": "ブルーフェザー",
        "FR": "Plumage Bleu",
        "DE": "Blaugefiedert",
        "ES": "Plumaje Azul",
        "IT": "Piume Azzurre",
        "KOR": "블루 페더",
        "CHS": "蓝羽毛",
        "CHT": "藍羽毛",
        "SPRITE": "/images/sprites/a_960-1.png"
    },
    "Squawkabilly-Yellow": {
        "NO": 960,
        "EN": "Yellow Plumage",
        "JP": "イエローフェザー",
        "FR": "Plumage Jaune",
        "DE": "Gelbgefiedert",
        "ES": "Plumaje Amarillo",
        "IT": "Piume Gialle",
        "KOR": "옐로 페더",
        "CHS": "黄羽毛",
        "CHT": "黃羽毛",
        "SPRITE": "/images/sprites/a_960-2.png"
    },
    "Squawkabilly-White": {
        "NO": 960,
        "EN": "White Plumage",
        "JP": "ホワイトフェザー",
        "FR": "Plumage Blanc",
        "DE": "Weißgefiedert",
        "ES": "Plumaje Blanco",
        "IT": "Piume Bianche",
        "KOR": "화이트 페더",
        "CHS": "白羽毛",
        "CHT": "白羽毛",
        "SPRITE": "/images/sprites/a_960-3.png"
    },
    "Tatsugiri": {
        "NO": 952,
        "EN": "Curly Form",
        "JP": "そったすがた",
        "FR": "Forme Courbée",
        "DE": "Gebogene Form",
        "ES": "Forma Curvada",
        "IT": "Forma Arcuata",
        "KOR": "젖힌 모습",
        "CHS": "上弓姿势",
        "CHT": "上弓姿勢",
        "SPRITE": "/images/sprites/a_952.png"
    },
    "Tatsugiri-Droopy": {
        "NO": 952,
        "EN": "Droopy Form",
        "JP": "たれたすがた",
        "FR": "Forme Affalée",
        "DE": "Hängende Form",
        "ES": "Forma Lánguida",
        "IT": "Forma Adagiata",
        "KOR": "늘어진 모습",
        "CHS": "下垂姿势",
        "CHT": "下垂姿勢",
        "SPRITE": "/images/sprites/a_952-1.png"
    },
    "Tatsugiri-Stretchy": {
        "NO": 952,
        "EN": "Stretchy Form",
        "JP": "のびたすがた",
        "FR": "Forme Raide",
        "DE": "Gestreckte Form",
        "ES": "Forma Recta",
        "IT": "Forma Tesa",
        "KOR": "뻗은 모습",
        "CHS": "平挺姿勢",
        "CHT": "平挺姿势",
        "SPRITE": "/images/sprites/a_952-2.png"
    },
    "Dudunsparce-Two-Segment": {
        "NO": 917,
        "EN": "Two-Segment Form",
        "JP": "ふたふしフォルム",
        "FR": "Forme Double",
        "DE": "Zweisegmentform",
        "ES": "Forma Binodular",
        "IT": "Forma Bimetamero",
        "KOR": "두 마디폼",
        "CHS": "二节形态",
        "CHT": "二節形態",
        "SPRITE": "/images/sprites/a_917.png"
    },
    "Dudunsparce-Three-Segment": {
        "NO": 917,
        "EN": "Three-Segment Form",
        "JP": "みつふしフォルム ",
        "FR": "Forme Triple",
        "DE": "Dreisegmentform",
        "ES": "Forma Trinodular",
        "IT": "Forma Trimetamero",
        "KOR": "세 마디폼",
        "CHS": "三节形态",
        "CHT": "三節形態",
        "SPRITE": "/images/sprites/a_917-1.png"
    },
    "Gimmighoul-Chest": {
        "NO": 976,
        "EN": "Chest Form",
        "JP": "はこフォルム",
        "FR": "Forme Coffre",
        "DE": "Truhenform",
        "ES": "Forma Cofre",
        "IT": "Forma Scrigno",
        "KOR": "상자폼",
        "CHS": "宝箱形态",
        "CHT": "寶箱形態",
        "SPRITE": "/images/sprites/a_976.png"
    },
    "Gimmighoul-Roaming": {
        "NO": 976,
        "EN": "Roaming Form",
        "JP": "とほフォルム",
        "FR": "Forme Marche",
        "DE": "Wanderform",
        "ES": "Forma Andante",
        "IT": "Forma Ambulante",
        "KOR": "도보폼",
        "CHS": "徒步形态",
        "CHT": "徒步形態",
        "SPRITE": "/images/sprites/a_976-1.png"
    }
}